module.exports = __webpack_public_path__ + "static/media/book-page2x.f56a8aa5.jpg";